import axios from 'axios'
import { GetBaseUrl } from '@/utils/ConfigHelper'
import Response from '@/utils/Videomonster/Common/Response'
import { PUBLIC_ERROR_CODE } from '@/utils/Error/Constants'
import { GetPublicErrorCode } from '@/utils/Error/Handler'

/**
 * @param token
 * @param {{
 *  templateId: string
 * }} data
 * @return {Promise<Response>}
 */

const GetVideoPrviews = async (token, data) => {
    try {
        const url = `${GetBaseUrl()}/apis/videos/${data.templateId}/previews`;
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const response = await axios.get(url, config);

        const result = (response.status === 200);
        const resultData = response.data.data;

        return new Response(result, resultData);
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}
/**
 * @param token
 * @param {{
 *  videoId: String
 *  startPoint: Number
 *  duration: Number
 * }} data
 * @return {Promise<Response>}
 */
const PostGifRender = async (token, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/videos/gif-render`;
        const body = { ...data }
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const response = await axios.post(url, body, config);
        const result = (response.status === 200);
        const resultData = response.data.message;

        return new Response(result, resultData);
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_CAN_NOT_GIF_RENDER:
            case PUBLIC_ERROR_CODE.ERR_INVALID_ACCESS:
                return new Response(false, publicErrorCode)
            default:
                throw e
        }
    }
}
/**
* @param token
* @param {{
*  templateId: string
*  videoId: string
* }} data
* @return {Promise<Response>}
*/

const PostChangeTemplate = async (token, data) => {
    try {
        const url = `${GetBaseUrl()}/apis/videos/${data.videoId}/copy/change-template`;
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const response = await axios.post(url, { templateId: data.templateId }, config);

        const result = (response.status === 200);
        const resultData = response.data.data;

        return new Response(result, resultData);
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
* @param token
* @param {{
*  templateId: string,
*  videoId: string
* }} data
* @return {Promise<Response>}
*/
const GetChangeTemplateInfo = async (token, data) => {
    try {
        const url = `${GetBaseUrl()}/apis/videos/${data.videoId}/change-template`;
        const config = { headers: { Authorization: `Bearer ${token}` }, params: { tId: data.templateId } };
        const response = await axios.get(url, config);

        const result = (response.status === 200);
        const resultData = response.data.data;

        return new Response(result, resultData);
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_NOT_SUPPORTED:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}


export default {
    GetVideoPrviews,
    PostGifRender,
    PostChangeTemplate,
    GetChangeTemplateInfo
}